import { render } from "./LogOut.vue?vue&type=template&id=1ba7d823"
import script from "./LogOut.vue?vue&type=script&lang=js"
export * from "./LogOut.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__